import { render, staticRenderFns } from "./MSPointHistoryListTable.vue?vue&type=template&id=1188afe2&"
import script from "./MSPointHistoryListTable.vue?vue&type=script&lang=js&"
export * from "./MSPointHistoryListTable.vue?vue&type=script&lang=js&"
import style0 from "./MSPointHistoryListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports